var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-list",
    _vm._l(_vm.options, function (option, idx) {
      return _c(
        "v-list-item",
        { key: idx },
        [
          _c("SoliAvatarBtn", {
            attrs: {
              title: option.title,
              icon: option.icon,
              blue: "",
              disabled: option.disabled,
              subtitleBottom: option.subtitleBottom,
            },
            on: {
              click: function ($event) {
                return _vm.$emit("input", option.value)
              },
            },
          }),
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }